import { Box, Container, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../Assets/css/HealthQuickQuote.css";
import "../../Assets/css/globalStyle.css";

import QuickQuoteForm from "./QuickQuoteForm";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Axios from "axios";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import { useLocation } from "react-router-dom";
import { getLocalData, setLocalData } from "../../Utilities/Common/source";

const QuickQuote = () => {
  const location = useLocation();
  const [productDetails, setProductDetails] = useState([]);
  let localSource;

  const params = new URLSearchParams();

  location.state?.source === "b2c"
    ? setLocalData("source", "b2c")
    : setLocalData("source", "posp");
  localSource = getLocalData("source");
  console.log("QQ localSource: ", localSource);

  useEffect(() => {
    // localStorage.clear();
  }, []);

  return (
    <div className=" bg-white QQ_container">
      <div className=" ">
        <CategoryHeader title="Health Insurance" />
      </div>
      <div></div>
      <div>
        <QuickQuoteForm source={localSource} />
      </div>
    </div>
  );
};

export default QuickQuote;
